import { api } from '../client'
import type { RequestOptions } from '../client'
import type { AiAnalysisStatus, BulkAiAnalysisResult } from './types'

export const aiAnalysisHttpApi = {
  statuses: (ids: number[], options?: RequestOptions): Promise<AiAnalysisStatus[]> =>
    api.get<AiAnalysisStatus[]>(`/procurements/ai-analysis/status?ids=${ids.join(',')}`, options),
  trigger: (procurementId: number, options?: RequestOptions): Promise<void> =>
    api.post<void>(`/procurements/${procurementId}/ai-analysis`, undefined, options),
  triggerBulk: (
    procurementIds: number[],
    options?: RequestOptions,
  ): Promise<BulkAiAnalysisResult> =>
    api.post<BulkAiAnalysisResult>('/procurements/ai-analysis/bulk', { procurementIds }, options),
  // Cooperative cancel: the backend flips the tender's status immediately, but
  // an in-flight model call may already be finishing in the background — its
  // result is discarded server-side and never overwrites the score. Idempotent.
  cancel: (procurementId: number, options?: RequestOptions): Promise<void> =>
    api.post<void>(`/procurements/${procurementId}/ai-analysis/cancel`, undefined, options),
}
